module.exports = __webpack_public_path__ + "img/racecourse-barrowdalePark-turf-1800.96b2ca44.svg";